module.exports = __webpack_public_path__ + "static/media/german_antiair_motorized_120.69af39c1.png";